import React from 'react';
import './SecondaryText.css';

export const SecondaryText = ({ text, alignText = '', className = '' }) => (
  <p className={`secondaryText ${alignText} ${className}`}>{text}</p>
);
